import * as actionTypes from "./types";

const initailstate = {
  companyDetails: null,
  loading: false,
  error: null,
  crudError: null,
  crudLoading: false,
};

const companyReducer = (state = initailstate, action) => {
  switch (action.type) {
    case actionTypes.GET_COMPANY_DETAILS_INITIATED:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.GET_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        companyDetails: action.payload.company,
      };
    case actionTypes.GET_COMPANY_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actionTypes.UPDATE_COMPANY_DETAILS_INITIATED: {
      return {
        ...state,
        crudLoading: true,
        crudError: null,
      };
    }
    case actionTypes.UPDATE_COMPANY_DETAILS_SUCCESS: {
      return {
        ...state,
        settings: action.payload.setting,
        crudError: null,
        crudLoading: false,
      };
    }
    case actionTypes.UPDATE_COMPANY_DETAILS_FAILED: {
      return {
        ...state,
        crudError: action.payload,
        crudLoading: false,
      };
    }
    default:
      return state;
  }
};

export default companyReducer;
